function ApplicationCore() {

}

ApplicationCore.utilities = {
    /*
        This will apply the text shape in uniform. By updating the embellishment data of the application
        @params application, embellishment
    */
    updateEmbellishment: function(application, embellishment, options) {
        var settings = ub.current_material.settings;
        var application_embellishment_code = application.id + '_' + embellishment.id;
        var scale_settings;
        var _status;

        if (typeof settings.applications[application.id] !== 'undefined') {
            scale_settings = settings.applications[application.id].scale;
        }

        var settings_obj = settings.applications[application.id];
        var embellishment_obj = settings_obj.embellishment;
        var view = ub[application.perspective + '_view'];
        var view_objects = ub.objects[application.perspective + '_view'];

        settings_obj.embellishment = embellishment;
        settings_obj.fromChangeColor = (typeof options !== "undefined");

        var sprite_collection = ub.funcs.renderApplication($.ub.create_embellishment, settings_obj, application.id);
        var uniform_type = ub.current_material.material.type;
        var app_containers = ub.current_material.containers[uniform_type].application_containers;
        var sprite = sprite_collection;

        app_containers[application.id] = {};
        app_containers[application.id].object = {
            sprite: sprite_collection,
        };

        _status = settings_obj.status;

        if (typeof settings_obj.status === "undefined") {
            _status = "on";
        }

        ub.funcs.toggleApplication(application.id, _status);

        // Skip activate when called on load prep
        if (ub.data.afterLoadCalled === 0) {
            return;
        }
    },

    /*
        This will change the current property of the application. Convert team name into text shape.
        @params application, text_type, textLayoutType
    */
    changeApp: function(settingsObject, text_type, textLayoutType) {
        var _settingsObject = settingsObject;
        var _id = parseInt(_settingsObject.code);

        var _applicationType = 'embellishments';
        var _size = settingsObject.font_size;

        ub.funcs.deActivateApplications();
        _settingsObject.application_type = _applicationType;
        _settingsObject.type = _applicationType;
        _settingsObject.object_type = _applicationType;

        //  Team name and player name
        _settingsObject.textLayoutType = textLayoutType;

        _settingsObject.application.name = _applicationType.toTitleCase();
        _settingsObject.application.type = _applicationType;
        _settingsObject.text_type = text_type;

        // Set Application type to embellishment
        _settingsObject.application.name = ub.utilities.titleCase(TextShapeCore.TEXT_SHAPE_TYPE);
        _settingsObject.application.type = TextShapeCore.TEXT_SHAPE_TYPE;

        ub.funcs.setAppSize(_id, _size);
        _settingsObject.status = "on";
        ub.funcs.LSRSBSFS(parseInt(_id));
        ub.funcs.renderLocations();
    },

    /*
        This will remove all unnecessary setting in application
        @params application, text_type, textLayoutType
    */
    removeSettingsInTextApplication: function(application) {
        if (typeof application.embellishment !== "undefined") {
            delete application.embellishment;
        }

        if (typeof application.mascot !== "undefined") {
            delete application.mascot;
        }

        if (typeof application.text_type !== "undefined") {
            delete application.text_shape_type;
            delete application.mascot;
            delete application.textShapeConfig;
            delete application.textLayoutType;
            delete application.text_type;
        }
    },

    removeSettingsInMascotApplication: function(application) {
        if (typeof application.embellishment !== "undefined") {
            delete application.embellishment;
        }

        if (typeof application.font_obj !== "undefined") {
            delete application.font_obj;
        }
    },

    removeSettingsInEmbellishmentApplication: function(application) {
        if (typeof application.mascot !== "undefined") {
            delete application.mascot;
        }

        if (typeof application.font_obj !== "undefined") {
            delete application.font_obj;
        }

        if (typeof application.color_array !== "undefined") {
            delete application.color_array;
        }
    },

    isPlayerNumber: function(applicationType) {
        if (applicationType === "front_number" || applicationType === "back_number" || applicationType === "sleeve_number" || applicationType === "shoulder_number") {
            return true;
        }

        return false;
    },

    rotateApplication: function(rotation, code) {
        var applicationObject = ub.funcs.getApplicationSettings(code);

        if (typeof applicationObject !== "undefined") {
            _.each(applicationObject.application.views, function(view) {
                var object = ub.objects[view.perspective + '_view']['objects_' + applicationObject.code];
                if (typeof object !== "undefined") {
                    object.rotation = rotation;
                }
            });
        } 
    },

    computeRotation: function(applicationSettings) {
        var _v = ub.funcs.getPrimaryView(applicationSettings.application);
        var rotation = ub.objects[_v + '_view']['objects_' + applicationSettings.code].rotation;
        var computedRotation = (rotation / Math.PI) * 180.00;

        var angle = 0;
        angle = (computedRotation * 5) / 18;
        if (angle < 0 && angle > -60) {
            angle += 60 + 40;
        }

        return Math.round(angle);
    },

    computeScale: function(applicationSettings) {
        var _multiplier = 100;
        var scale;
        
        if (TextShapeCore.utilities.isTextShape(applicationSettings.code)) {
            _multiplier = 15;
        } else {
            _multiplier = 10;
        }

        var _v = ub.funcs.getPrimaryView(applicationSettings.application);
        var _start = (_multiplier * ub.objects[_v + '_view']['objects_' + applicationSettings.code].scale.x) / 3;
        scale = _start * 30 / 2;
        
        return Math.round(scale);
    },

    computePosition: function(applicationSettings) {
        var _v = ub.funcs.getPrimaryView(applicationSettings.application);
        var x_axis = ub.objects[_v + '_view']['objects_' + applicationSettings.code].position.x;
        var y_axis = ub.objects[_v + '_view']['objects_' + applicationSettings.code].position.y;

        y_axis = y_axis / ub.dimensions.height * 100;
        x_axis = x_axis / ub.dimensions.width * 100;

        return {
            x: Math.round(x_axis),
            y: Math.round(y_axis)
        };
    },

    initApplicationTools: function(applicationSettings) {
        var self = this;
        ApplicationCore.view.scaleSlider(applicationSettings);
        ApplicationCore.view.positionXSlider(applicationSettings);
        ApplicationCore.view.positionYSlider(applicationSettings);
        ApplicationCore.view.rotationSlider(applicationSettings);
    },

    isFlippedApplication: function(code) {
        var _applicationObject = ub.funcs.getApplicationSettings(code);
        var flipped = _applicationObject.application.views[0].application.flip;
        if (flipped === 1) {
            return true;
        } else {
            return false;
        }
    },

    descArc: function(x, y, radius, startAngle, endAngle) {
        var start = this.polarToCartesian(x, y, radius, endAngle);
        var end = this.polarToCartesian(x, y, radius, startAngle);

        var arcSweep = endAngle - startAngle <= 180 ? "0" : "1";

        var d = [
            "M", start.x, start.y, 
            "A", radius, radius, 0, arcSweep, 0, end.x, end.y
        ].join(" ");

        return d;
    },

    polarToCartesian: function(centerX, centerY, radius, angleInDegrees) {
        var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
        
        return {
            x: centerX + (radius * Math.cos(angleInRadians)),
            y: centerY + (radius * Math.sin(angleInRadians))
        };
    },

    renderPatternPreviewAndArch: function(applicationSettings, patternBlank) {
        var length = 360 / _.size(ub.current_material.settings.team_colors);
        var patternObject = typeof patternBlank !== "undefined" ? patternBlank : applicationSettings.pattern_obj;
        patternObject.currentLayer = 1;

        // Render Path
        _.each(ub.current_material.settings.team_colors, function (color, index) {
            var start = index * length;
            var end = start + length;
            var arcID = "application-arc-" + color.color_code;
            var archSettings = ApplicationCore.utilities.descArc(200, 150, 100, start, end);

            document.getElementById(arcID).setAttribute("d", archSettings);
        });

        // Render Preview
        Pattern.core.patternPreviewForApplication(patternObject, function(preview) {
            var container = $(".application-pattern-color-wheel .svg-color-wheel");
            $("pattern#image > image", container).attr("xlink:href", preview);
        });
    },

    removeDefaultSettingOfApplication: function(applicationSettings) {
        delete applicationSettings.custom_obj;
        delete applicationSettings.scale_type;
        delete applicationSettings.custom_size_type;
        delete applicationSettings.application.views[0].application.scale;
    }
};

ApplicationCore.events = {
    isInit: true,

    init: function() {
        var self = this;
        var parent = $("#primary_options_container");

        if (self.isInit) {
            $(parent).on("click", ".application-container .application-status", self.changeApplicationStatus);
            $(parent).on("click", ".application-container .show-slider", self.onShowSliders);
            $(parent).on("click", ".application-container .show-font-guide", self.onShowFontGuide);
            $(parent).on("click", ".application-container .open-change-app-dd", self.onShowChangeApplication);
            $(parent).on("click", "#changeAppDropdown .application-type-item", self.onChangeApplicationType);

            self.isInit = false;
        }
    },

    changeApplicationStatus: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var currentStatus = $(this).data("status");
        
        if (currentStatus === "on") {
            $(this).data("status", "off");
            $(this).html("(show)");

            $(".application-container .application-cover").removeClass("uk-hidden");

            $(".application-container .show-slider").html("(show)");
            $(".application-container .application-slider").addClass("uk-hidden");
            $(".application-container .measurement-forms").removeClass("uk-hidden");
        } else {
            $(this).data("status", "on");
            $(this).html("(hide)");
            $(".application-container .application-cover").addClass("uk-hidden");

            $(".application-container .show-slider").html("(hide)");
            $(".application-container .application-slider").removeClass("uk-hidden");
            $(".application-container .measurement-forms").addClass("uk-hidden");
        }

        ApplicationCore.funcs.changeApplicationStatus(application_code, currentStatus);
    },

    onShowSliders: function() {
        if ($(".application-container .application-slider").hasClass("uk-hidden")) {
            $(this).html("(hide)");
            $(".application-container .application-slider").removeClass("uk-hidden");
            $(".application-container .measurement-forms").addClass("uk-hidden");
        } else {
            $(this).html("(show)");
            $(".application-container .application-slider").addClass("uk-hidden");
            $(".application-container .measurement-forms").removeClass("uk-hidden");
        }
    },

    onShowFontGuide: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        ApplicationCore.view.renderGAFontTool(application_code);
    },

    onShowChangeApplication: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);
        var tmpl = _.template($("#change-application-type-template").html());

        var types = [];

        var application_type = TextShapeCore.utilities.isTextShape(applicationSettings.code) ? applicationSettings.textLayoutType: applicationSettings.application_type;

        _.map(applicationSettings.validApplicationTypes, function(type) {
            if (type === "number") {
                types.push({
                    title: "player_number".toTitleCase(),
                    type: "player_number",
                    thumbnail: "/images/main-ui/icon-number-large.png",
                    isSelected: ApplicationCore.utilities.isPlayerNumber(application_type) ? "uk-active" : "" 
                });
            }

            if (type === "player_name" || type === "team_name") {
                types.push({
                    title: type.toTitleCase(),
                    type: type,
                    thumbnail: "/images/main-ui/icon-text-large.png",
                    isSelected: application_type === type ? "uk-active" : "" 
                });
            }

            if (type === "embellishments" || type === "logo") {
                var find = _.find(types, {type: "embellishments"});

                if (typeof find === "undefined") {
                    types.push({
                        title: "Custom Mascot",
                        type: "embellishments",
                        thumbnail: "/images/main-ui/icon-embellishments-large.png",
                        isSelected: application_type === "embellishments" || application_type === "mascot" ? "uk-active" : "",
                    });
                }
            }
        });

        $("#changeAppDropdown").html("");
        $("#changeAppDropdown").html(tmpl({
            application_types: types
        }));

        UIkit.dropdown("#changeAppDropdown", {
            stack: true,
        }).show();
    },

    onChangeApplicationType: function() {
        var application_code = $(this).closest(".application-container").data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);
        var _type = $(this).data('application-type');

        ub.funcs.resetFlipStatus(applicationSettings);
        ub.funcs.changeApplicationType(applicationSettings, _type);
    }
};

ApplicationCore.funcs = {
    changeApplicationStatus: function(application_code, currentStatus) {
        var status;

        if (currentStatus === "on") {
            status = 'off';
            ub.funcs.deactivateMoveTool();
        } else {
            ub.funcs.activateMoveTool(application_code);
            status = 'on';
        }
        
        if (status === "on") {
            ub.funcs.LSRSBSFS(parseInt(application_code));
        }

        ub.funcs.toggleApplication(application_code, status);
        // For Matching Application
        var _matchingID = ub.data.matchingIDs.getMatchingID(application_code);

        if (typeof _matchingID !== "undefined") {
            ub.funcs.toggleApplication(_matchingID.toString(), status);
        }

        ub.funcs.disableSubmitOnUniforms();
    },

    changeTextApplicationColor: function(application_code, layer_number, layer_name, color_object, callback) {
        var applicationSettings = ub.funcs.getApplicationSettings(application_code);
        var _layer = _.find(applicationSettings.accent_obj.layers, {
            name: layer_name
        });

        if (TextShapeCore.utilities.isTextShape(applicationSettings.code)) {
            if (applicationSettings.text_shape_type === "arc") {
                TextShapeCore.customControllers.changeArcColor(applicationSettings, layer_name, layer_number, color_object);
            }
            TextShapeCore.funcs.changeColor(applicationSettings, layer_name, layer_number, color_object);
        } else {
            _layer.default_color = color_object.hex_code;
            applicationSettings.color_array[layer_number - 1] = color_object;
            applicationSettings.colorArrayText = _.pluck(applicationSettings.color_array, "color_code");

            ub.funcs.changeFontFromPopup(applicationSettings.font_obj.id, applicationSettings);

            var _matchingID;
            var _matchingSide;

            _matchingID = ub.data.matchingIDs.getMatchingID(applicationSettings.code);

            if (typeof _matchingID !== "undefined") {
                var _matchingSettingsObject = _.find(ub.current_material.settings.applications, {
                    code: _matchingID.toString()
                });
                
                if (typeof _matchingSettingsObject !== "undefined") {
                    var _layer = _.find(_matchingSettingsObject.accent_obj.layers, {
                        name: layer_name
                    });

                    _layer.default_color = color_object.hex_code;
                    _matchingSettingsObject.color_array[layer_number - 1] = color_object;
                    _matchingSettingsObject.colorArrayText = _.pluck(applicationSettings.color_array, "color_code");

                    ub.funcs.changeFontFromPopup(_matchingSettingsObject.font_obj.id, _matchingSettingsObject);
                }
            }
        }

        if (_.isFunction(callback)) {
            callback();
        }
    },

    changeText: function(_val, applicationSettings) {
        var _isFreeFormEnabled  = ub.funcs.isFreeFormToolEnabled(applicationSettings.code);
        applicationSettings.text = _val;
        /// Set Auto Font Size on Team Name, Baseball / Fastpitch
        if (parseInt(applicationSettings.code) === 1 && (ub.data.uniformWithPipings.hasPipings(ub.config.sport))) {
            if (applicationSettings.application_type === "team_name") {
                var _len = _val.length;
                var _size = applicationSettings.font_size;

                if (_len <= 4) {
                    _size = 4;
                } else if (_len >= 5 && _len <= 7) {
                    _size = 3;
                } else if (_len >= 8) {
                    _size = 2;
                }

                ub.funcs.setAppSize(applicationSettings.code, _size);
                ub.funcs.setAUIActiveSize(_size);
            }
        }

        /// End Set Auto Font Size
        ub.funcs.changeFontFromPopup(applicationSettings.font_obj.id, applicationSettings);

        // cancel automatic changing of application (e.g. all team names changes)
        if (_isFreeFormEnabled) {
            return;
        }
        
        _.each (ub.current_material.settings.applications, function (_application) {
            if (_application.type !== "logo" && _application.type !== "mascot") {
                if (applicationSettings.type.indexOf('number') !== -1 && _application.type.indexOf('number') !== -1) {
                    _application.text = _val;
                    ub.funcs.changeFontFromPopup(_application.font_obj.id, _application);
                }
            }
        });
    },

    changeApplicationPatternColor: function(settingsObj, color_code, _layer_no, callback) {
        var _colorObj = ub.funcs.getColorByColorCode(color_code);
        var _layer = _.find(settingsObj.pattern_obj.layers, {layer_no: _layer_no});

        _layer.default_color = _colorObj.hex_code;
        _layer.color_code = color_code;
        _layer.colorObj = _colorObj;

        _applicationSettings = ub.current_material.settings.applications[settingsObj.application.id];
        _applicationViewObjects = ub.funcs.getApplicationViewObjects(settingsObj.application.id);

        _.each(_applicationViewObjects, function (viewObject) {
            _primaryView = viewObject.perspective;
            _primaryViewStr = _primaryView + '_view';
            _patternIDStr = 'pattern_' + settingsObj.application.id;
            _sprites = ub.objects[_primaryViewStr][_patternIDStr];
            _layer = _sprites.children[_layer_no - 1];
            _layer.tint = parseInt(_colorObj.hex_code, 16);
        });

        var _matchingID;
        var _matchingSide;
        var _matchingSettingsObject;

        _matchingID = ub.data.matchingIDs.getMatchingID(settingsObj.code);

        if (typeof _matchingID !== "undefined") {
            _applicationSettings = ub.current_material.settings.applications[_matchingID];
            _applicationViewObjects = ub.funcs.getApplicationViewObjects(_matchingID);
            _matchingSettingsObject = _.find(ub.current_material.settings.applications, {code: _matchingID.toString()});

            _.each(_applicationViewObjects, function (viewObject) {
                _primaryView = viewObject.perspective;
                _primaryViewStr = _primaryView + '_view';
                _patternIDStr = 'pattern_' + _matchingSettingsObject.application.id;
                _sprites = ub.objects[_primaryViewStr][_patternIDStr];

                _layer = _sprites.children[_layer_no - 1];
                _layer.tint = parseInt(_colorObj.hex_code, 16);
            });
        }

        if (_.isFunction(callback)) {
            callback();
        }
    },

    changeMascotColor: function(layer_no, colorObj, applicationSettings, callback) {
        ub.funcs.removeApplicationByID(applicationSettings.code);
        var _layer = _.find(applicationSettings.mascot.layers_properties, {layer_number: layer_no.toString()});
        
        if (typeof _layer !== "undefined") {
            _layer.default_color = colorObj.color_code;
        }
    
        applicationSettings.color_array[layer_no - 1] = colorObj;
        ub.funcs.update_application_mascot(applicationSettings.application, applicationSettings.mascot, {fromChangeColor: true});

        if (_.isFunction(callback)) {
            callback();
        }
    },

    afterRender: function(applicationSettings) {
        // Bind Global Application Events
        ApplicationCore.events.init();
        // Slider Initiator function
        ApplicationCore.utilities.initApplicationTools(applicationSettings);
        
        ub.funcs.activateMoveTool(applicationSettings.code);
        ub.funcs.activateLayer(applicationSettings.code);
        ub.funcs.afterActivateApplication(applicationSettings.code);
        ub.funcs.activateCustomSizeType(applicationSettings);

        if (applicationSettings.status === "off") {
            $(".application-container .application-status").data("status", "off");
            $(".application-container .application-status").html("(show)");

            $(".application-container .application-cover").removeClass("uk-hidden");

            $(".application-container .show-slider").html("(show)");
            $(".application-container .application-slider").addClass("uk-hidden");
            $(".application-container .measurement-forms").removeClass("uk-hidden");
        }
    },

    applyMascotOnUniform: function(stockID, application) {
        ub.isMessageIsCalled = true;
        is.isMessage(stockID, application.code, true);
        
        var _matchingID = ub.data.matchingIDs.getMatchingID(application.code);
        if (typeof _matchingID !== "undefined") {
            var _matchingSettingsObject = _.find(ub.current_material.settings.applications, {code: _matchingID.toString()});
            if (typeof _matchingSettingsObject !== "undefined") {
                ub.isMessageIsCalled = true;
                is.isMessage(stockID, _matchingSettingsObject.code, true);
            }
        }
    },

    applyMascotAsPatternInApplication: function(stockID, application) {
        ub.isMessageIsCalled = true;
        var code = typeof application !== "undefined" ? application.code : undefined;
        is.isMessageMascotAsPattern(stockID, code, true);

        if (ub.partMascotAsPattern) {
            ub.funcs.clearPatternUI();
            ub.funcs.activatePatterns();
        } else if (ub.applicationMascotAsPattern) { 
            ub.funcs.activateApplications(application.code);
        }
    },

    createTextApplication: function(applicationObject, applicationType) {
        ApplicationCore.utilities.removeSettingsInTextApplication(applicationObject);

        // Change Root Application Type
        applicationObject.type = applicationType;
        applicationObject.object_type = 'text object';
        applicationObject.application_type = applicationType;
        // Change Application Type inside application object
        applicationObject.application.name = applicationType.toTitleCase();
        applicationObject.application.type = applicationType;

        // Remove Mascot Pattern
        delete applicationObject.mascot_pattern;
        delete applicationObject.mascot_pattern_settings;

        // Force Pattern to be Blank
        applicationObject.pattern_obj = _.find(ub.data.patterns.items, {code: "blank"});
        applicationObject.withPattern = false;
        applicationObject.withMascotPattern = false;

        ub.create_application(applicationObject, undefined);
        // Render Application
        TextApplication.render(applicationObject.code);
    },

    createMascotApplication: function(applicationSettings, mascotObject, size, color_array) {
        var _applicationType = "mascot";
        var defaultSize;
        var _id = parseInt(applicationSettings.code);

        ub.funcs.deActivateApplications();

        applicationSettings.application_type = _applicationType;
        applicationSettings.type = _applicationType;
        applicationSettings.object_type = _applicationType;
        applicationSettings.mascot = mascotObject;
        applicationSettings.color_array = color_array;
        applicationSettings.application.name = _applicationType.toTitleCase();
        applicationSettings.application.type = _applicationType;

        if (typeof size !== "undefined") {
            defaultSize = size;
        } else {
            var getSize = ub.funcs.getDefaultSize(_applicationType, _id);
            if (typeof getSize !== 'undefined') {
                defaultSize = getSize;
            }
        }

        ub.funcs.setAppSize(_id, defaultSize);
        ub.funcs.clearInksoftID(applicationSettings); // Remove Inksoft ID from settings object in case it was changed from custom to stock

        ub.funcs.update_application_mascot(applicationSettings.application, applicationSettings.mascot);
        ub.current_material.settings.applications[_id] = applicationSettings;
        ub.funcs.LSRSBSFS(parseInt(_id));
        ub.funcs.updateLayerTool();

        // Remove Unused configuration
        ApplicationCore.utilities.removeSettingsInMascotApplication(applicationSettings);
        ub.funcs.activateMascots(applicationSettings.code);
    },

    createEmbellishmentApplication: function(applicationSettings, embellishmentObject, size) {
        var _applicationType = 'embellishments';
        var defaultSize = 4;
        var _id = parseInt(applicationSettings.code);

        if (typeof size !== "undefined") {
            defaultSize = size;
        }

        applicationSettings.font_obj = ub.funcs.getSampleFont();
        applicationSettings.application_type = _applicationType;
        applicationSettings.type = _applicationType;
        applicationSettings.object_type = _applicationType;
        applicationSettings.embellishment = embellishmentObject;
        applicationSettings.color_array = ub.funcs.getDefaultColors();
        applicationSettings.application.name = _applicationType.toTitleCase();
        applicationSettings.application.type = _applicationType;

        ub.funcs.setAppSize(_id, defaultSize);

        ub.funcs.update_application_embellishments(applicationSettings.application, applicationSettings.embellishment);
        ub.current_material.settings.applications[_id] = applicationSettings;
        ub.funcs.LSRSBSFS(parseInt(_id));
        ub.funcs.updateLayerTool();

        // Remove unused configuration
        ApplicationCore.utilities.removeSettingsInEmbellishmentApplication(applicationSettings);

        // Render in Right Panel
        ub.funcs.activateEmbellishments(applicationSettings.code);
    },

    createNewPlainApplication: function(perspective, part, side, source, callback) {
        var _pha = _.find(ub.data.placeHolderApplications, {perspective: perspective});
        var _phaSettings = ub.utilities.cloneObject(ub.data.placeholderApplicationSettings[_pha.id]);
        var _part = part;
        var _sport = ub.current_material.material.uniform_category;
        var _blockPattern = ub.current_material.material.block_pattern;
        var _primaryView = ub.funcs.getPrimaryView(_phaSettings.application);
        var _primaryViewObject = ub.funcs.getPrimaryViewObject(_phaSettings.application);
        
        var _withPlaceholderOverrides = false; // Placeholder overrides set on the backend
        var _perspectiveMarkForDeletion;

        // Process Uniforms with Extra Layer
        if (ub.data.sportsWithExtraLayer.isValid(ub.current_material.materials_options)) {
            var _extra = ub.objects[perspective + '_view']['extra'];

            if (typeof _extra === "undefined") {
                ub.utilities.error('Extra Layer not detected!');
            }

            if (typeof _extra !== "undefined") {
                var whiteList = ['Body', 'Front Body', 'Back Body', 'Body Left', 'Body Right', 'Front Leg', 'Right Leg'];
                if (_.contains(whiteList, _part)) {
                    _part = 'Extra';
                }
            }
        }

        var _exempted = ub.data.applicationProjectionExemptions.isExempted(perspective, part, ub.config.sport);
        // For Cowls, etc which uses a non-standard primary perspectives
        if (_exempted.isExempted) {
            var _primaryViewFound = _.find(_phaSettings.application.views, {perspective: _exempted.result.primary});

            if (typeof _primaryViewFound !== "undefined") {
                _primaryViewFound.application.isPrimary = 1;
                _primaryViewObject = _primaryViewFound;
                _phaSettings.application.views = _.filter(_phaSettings.application.views, function (view) {
                    var _ok = view.perspective !== "left" && view.perspective !== "right" && (_primaryView === "front") ? view.perspective === "back" : view.perspective === "front";
                    return _ok;
                });
            }

            ub.funcs.setActiveView('front');
        }

        // For instances where the part has left or right (e.g. sleeve), converts it to Left Sleeve
        if (typeof side !== "undefined" && side !== "na") {
            _part = side.toTitleCase() + " " + _part;
        }

        // Set Mascots Only for now on Socks
        _phaSettings.validApplicationTypes = ub.data.freeFormValidTypes.getItem(ub.current_material.material.uniform_category, _part).validTypes;

        _.each(_phaSettings.application.views, function (_perspectiveView) {
            var _perspective = _perspectiveView.perspective;
            // Get Center of Polygon 
            var _cx = ub.funcs.getCentoid(_perspective, _part);

            // CX Override 
            if (typeof _cx !== "undefined") {
                _perspectiveView.application.center = _cx;
                _perspectiveView.application.pivot = _cx;
            }

            if (typeof _perspectiveView !== "undefined") {
                var _overrides = ub.data.placeHolderOverrides.getOverrides(_sport, _part, _perspectiveView.perspective, _blockPattern);
                if (typeof _overrides !== "undefined") {
                    _withPlaceholderOverrides = true;
                    _perspectiveView.application.rotation = _overrides.rotation;
                    _perspectiveView.application.center = _overrides.position;
                    _perspectiveView.application.pivot = _overrides.position;
                } else {
                    // If has a placeholder override but this particular view has none set delete 
                    if (_withPlaceholderOverrides) {
                        _perspectiveMarkForDeletion = _perspectiveView.perspective;
                    }
                }
            }
        });

        if (typeof _perspectiveMarkForDeletion !== "undefined") {
            _phaSettings.application.views = _.filter(_phaSettings.application.views, function (view) {
                return view.perspective !== _perspectiveMarkForDeletion;
            });
        }

        _.each(_phaSettings.application.views, function (_perspectiveView) {
            // Get Center of Polygon
            var _cx = ub.funcs.getCentoid(_perspectiveView.perspective, _part);
            var _overrides = ub.data.placeHolderOverrides.getOverrides(_sport, _part, _perspectiveView.perspective, _blockPattern);

            // CX Override
            if (typeof _cx !== "undefined" && typeof _overrides === "undefined") {
                _perspectiveView.application.center = _cx;
                _perspectiveView.application.pivot = _cx;
            }

            if (typeof _perspectiveView !== "undefined" && typeof _overrides === "undefined") {
                if (parseInt(_perspectiveView.application.isPrimary) !== 1) {
                    var _bounds = ub.funcs.getBoundaries(_perspectiveView.perspective, _part, false);
                    var _overrideX;
                    
                    if (_primaryView === "front") {
                        if (typeof _bounds !== "undefined") {
                            if (_perspectiveView.perspective === "left") {
                                _overrideX = _bounds.minMax.minX;
                            }
                            
                            if (_perspectiveView.perspective === "right") {
                                _overrideX = _bounds.minMax.maxX;
                            }
                        }
                    }

                    if (_primaryView === "back") {
                        if (typeof _bounds !== "undefined") {
                            if (_perspectiveView.perspective === "left") {
                                _overrideX = _bounds.minMax.maxX;
                            }

                            if (_perspectiveView.perspective === "right") {
                                _overrideX = _bounds.minMax.minX;
                            }
                        }
                    }

                    if (_primaryView === "right") {
                        if (typeof _bounds !== "undefined") {
                            if (_perspectiveView.perspective === "front") {
                                _overrideX = _bounds.minMax.minX;
                            }

                            if (_perspectiveView.perspective === "back") {
                                _overrideX = _bounds.minMax.maxX;
                            }

                            // override x for Face Mask (Quickturn)
                            // temp fix to match front perspective
                            if (_.contains(['Face Mask (Quickturn)'], ub.config.sport)) {
                                if (_perspectiveView.perspective === "front") {
                                    _overrideX = _bounds.minMax.minX += 119;
                                }
                            }
                        }
                    }

                    if (_primaryView === "left") {
                        if (typeof _bounds !== "undefined") {
                            if (_perspectiveView.perspective === "front") {
                                _overrideX = _bounds.minMax.maxX;
                            }

                            if (_perspectiveView.perspective === "back") {
                                _overrideX = _bounds.minMax.minX;
                            }

                            // override x for Face Mask (Quickturn)
                            // temp fix to match front perspective
                            if (_.contains(['Face Mask (Quickturn)'], ub.config.sport)) {
                                if (_perspectiveView.perspective === "front") {
                                    _overrideX = _bounds.minMax.maxX -= 129;
                                }
                            }
                        }
                    }

                    _perspectiveView.application.position = {
                        x: _overrideX,
                        y: _primaryViewObject.application.center.x
                    };

                    _perspectiveView.application.center = {
                        x: _overrideX,
                        y: _primaryViewObject.application.center.y
                    };
                }
            }
        });

        var _newID = ub.funcs.getNewCustomID();
        var _newApplication = JSON.parse(JSON.stringify(_phaSettings)); // Quick Clone
        _newID = _newID;
        _newIDStr = _newID.toString();
        _newApplication.code = _newIDStr;
        _newApplication.application.id = _newIDStr;
        _newApplication.configurationSource = source;
        _newApplication.zIndex = ub.funcs.getNewZIndex();
        _newApplication.status = "on";

        if (ub.config.pageType === "Order Editor") {
            ub.funcs.addDefaultApplicationSize(_newApplication);
        }

        if (ub.data.placeHolderOverrideSports.isValid(ub.sport)) {
            var _tmp = [];

            _.each(_newApplication.application.views, function (view) {
                view.application.id = _newIDStr;
                // For Socks push only the primary perspective
                if (ub.funcs.isSocks()) {
                    if (view.application.isPrimary === 1) {
                        _tmp.push(view);
                    }
                } else {
                    _tmp.push(view);
                }
            });

            _newApplication.application.views = _tmp;
        }

        var _withBodyLeftRight = ub.data.withBodyLeftRight.isOk(ub.sport, ub.neckOption);

        if (_withBodyLeftRight) {
            if (_part === "Body Left") {
                _newApplication.application.views = _.filter(_newApplication.application.views, function (view) {
                    return view.perspective !== "right";
                });
            }

            if (_part === "Body Right") {
                _newApplication.application.views = _.filter(_newApplication.application.views, function (view) {
                    return view.perspective !== "left";
                });
            }
        }

        // Hide the perspective in the  free form modal;
        ub.data.manipulatePerspectives.getPerspectives(ub.sport, function(perspectives) {
            _.each(perspectives, function(perspective){
                _newApplication.application.views = _.filter(_newApplication.application.views, function (view) {
                    return view.perspective !== perspective.toLowerCase();
                });
            });
        });

        var _isSingleView = ub.data.categoriesWithSingleViewApplications.getItem(ub.config.sport, ub.config.type, ub.config.blockPattern, ub.config.option);

        if (_isSingleView) {
            _newApplication.application.views = _.filter(_newApplication.application.views, function (view) {
                return view.application.isPrimary === 1;
            });
        }

        ub.current_material.settings.applications[_newIDStr] = _newApplication;
        _newApplication.application.layer = _part;

        if (typeof ub.data.applications_transformed[_part] !== 'undefined') {
            ub.data.applications_transformed[_part][_newIDStr] = _newApplication.application;
            _newApplication.application.layer = _part;
        } else {
            if (typeof ub.data.applications_transformed["Body Panel Color"] !== 'undefined') {
                _newApplication.application.layer = "Body Panel Color";
                ub.data.applications_transformed["Body Panel Color"][_newIDStr] = _newApplication.application;
            }
        }

        ub.data.applications_transformed_one_dimensional[_newIDStr] = _newApplication.application;
        ub.funcs.renderLocations(_newIDStr);
        ub.funcs.pushOldState('add location', 'application', _newApplication, {applicationID: _newIDStr});

        if (_.isFunction(callback)) {
            callback(_newApplication);
        }
    }
};

ApplicationCore.view = {
    renderPattern: function(applicationSettings) {
        var tmpl = _.template($("#application-menu-tab-pattern").html());
        $(".application-container .application-color-settings-content").html("");

        $(".application-container .application-color-settings-content").html(tmpl({
            application: applicationSettings,
            colors: ub.current_material.settings.team_colors,
            blank: _.find(ub.data.patterns.items, {code: "blank"})
        }));

        if (typeof applicationSettings.pattern_obj !== "undefined") {
            if (typeof applicationSettings.pattern_obj.code !== "undefined") {
                Pattern.core.patternPreviewForApplication(applicationSettings.pattern_obj, "appPatternPreview", 300, 300, function(image) {
                    $(".application-container .application-color-settings-content").find("pattern-preview-container").removeClass("uk-hidden");
                    $(".application-container .application-color-settings-content").find("img.pattern-preview-src").prop("src", image);

                    // Hide Loader and Show Preview
                    $(".application-container .application-color-settings-content").find(".pattern-preview-container").removeClass("uk-hidden");
                    $(".application-container .application-color-settings-content").find(".loading-spinner").addClass("uk-hidden");
                });

                _.delay(function() {
                    ApplicationCore.view.applicationPatternSlider(applicationSettings);
                }, 100);
            }
        }
    },

    renderPatternV2: function(applicationSettings) {
        var tmpl = _.template($("#application-menu-tab-pattern-v2").html());
        $(".application-container .application-color-settings-content").html("");
        var blank = _.find(ub.data.patterns.items, {code: "blank"});
        var patternObj;

        if (typeof applicationSettings.pattern_obj !== "undefined") {
            patternObj = applicationSettings.pattern_obj;

            if (typeof applicationSettings.pattern_obj.mascot !== "undefined") {
                patternObj = blank;
            }
        } else {
            patternObj = blank;
        }

        $(".application-container .application-color-settings-content").html(tmpl({
            pattern: patternObj,
            active: _.first(patternObj.layers),
            colors: ub.current_material.settings.team_colors,
            blank: _.find(ub.data.patterns.items, {code: "blank"}),
            count: _.size(patternObj.layers)
        }));
        
        if (typeof applicationSettings.pattern_obj !== "undefined") {
            _.delay(function() {
                ApplicationCore.view.applicationPatternSlider(applicationSettings);
            }, 100);

            ApplicationCore.utilities.renderPatternPreviewAndArch(applicationSettings);
        } else {
            ApplicationCore.utilities.renderPatternPreviewAndArch(applicationSettings, blank);
        }
        
        // Bind events
        Pattern.applicationEvents.init(applicationSettings);
    },

    renderColors: function(applicationSettings) {
        var tmpl = _.template($("#application-menu-tab-color").html());
        $(".application-container .application-color-settings-content").html("");

        $(".application-container .application-color-settings-content").html(tmpl({
            application: applicationSettings,
            colors: ub.current_material.settings.team_colors,
        }));
    },

    renderMascot: function(applicationSettings) {
        var self = this;
        var tmpl = _.template($("#application-menu-mascot").html());
        $(".application-container .application-color-settings-content").html("");

        $(".application-container .application-color-settings-content").html(tmpl({
            application: applicationSettings,
            pattern_obj: _.find(ub.data.patterns.items, {code: "blank"})
        }));

        if (typeof applicationSettings.mascot_pattern !== "undefined") {
            self.mascotPatternScale(applicationSettings);
            self.mascotPatternPosition(applicationSettings);
            self.mascotPatternOpacity(applicationSettings);
        }

        $(".application-menu-switcher li.uk-active").removeClass("uk-active");
        $(".application-menu-switcher .application-color-menu-button[data-type='mascot']").parent().addClass("uk-active");
    },

    renderGAFontTool: function(application_id) {
        var applicationSettings = ub.funcs.getApplicationSettings(application_id);
        var _size = applicationSettings.font_size;
        var fontSizeData = ub.data.getPixelFontSize(applicationSettings.font_obj.id, _size, ub.active_view, {id: applicationSettings.code});
        var primaryView = ub.funcs.getPrimaryView(applicationSettings.application);
        var ubFontSizeData = ub.objects[primaryView + "_view"]["objects_" + applicationSettings.code].ubFontSizeData;
        
        var pixelFontSize = 100,
            outerStroke = 14,
            innerStroke = 11,
            offSetX = 0,
            offSetY = 0,
            xScale = 1,
            yScale = 1;

        if (typeof ubFontSizeData !== "undefined") {
            innerStroke = ubFontSizeData.strokeInner;
            outerStroke = ubFontSizeData.strokeOuter;
        }

        if (typeof fontSizeData !== "undefined") {
            pixelFontSize = fontSizeData.pixelFontSize;
            offSetX = fontSizeData.xOffset;
            offSetY = fontSizeData.yOffset;
            xScale = fontSizeData.xScale;
            yScale = fontSizeData.yScale;
        }

        ub.data.fontOriginalConfig = {
            pixelFontSize: pixelFontSize,
            offSetX: offSetX,
            offSetY: offSetY,
            scaleX: xScale,
            scaleY: yScale,
            strokeInner: innerStroke,
            strokeOuter: outerStroke
        };

        var tmpl = _.template($("#font-guide-template").html());

        $(".modifier_main_container .application-container").html("");
        $(".modifier_main_container .application-container").html(tmpl({
            fontSizeInch: _size,
            fontSizePx: pixelFontSize,
            offsetX: offSetX,
            offsetY: offSetY,
            scaleX: xScale,
            scaleY: yScale,
            strokeInner: innerStroke,
            strokeOuter: outerStroke,
            isSpecial: _.contains(ub.fontGuideIDs, window.ub.valid),
            views: applicationSettings.application.views
        }));

        GAFontTool.events.init();
    },

    scaleSlider: function(applicationSettings) {
        var start = ApplicationCore.utilities.computeScale(applicationSettings);
        var scaleSliders = document.querySelector(".slider-size");
        var labels = {
            first: "Small",
            last: "Large",
            rest: ""
        };

        SliderCore.rangeSlider(scaleSliders, start, labels, function(value) {
            var scale;

            if (applicationSettings.application_type === "mascot") {
                scale = value * 2 / 3;
            } else {
                scale = value * 2 / 30;
            }

            ub.funcs.updateScaleViaSlider(applicationSettings, scale);
        });
    },

    positionXSlider: function(applicationSettings) {
        var start = ApplicationCore.utilities.computePosition(applicationSettings);
        var scaleSliders = document.querySelector(".slider-position-x");
        var labels = {
            first: "Left",
            last: "Right",
            rest: ""
        };

        SliderCore.rangeSlider(scaleSliders, start.x, labels, function(value) {
            ub.funcs.updatePositionViaSlider(applicationSettings, value, 'x');
        });
    },

    positionYSlider: function(applicationSettings) {
        var start = ApplicationCore.utilities.computePosition(applicationSettings);
        var scaleSliders = document.querySelector(".slider-position-y");
        var labels = {
            first: "Up",
            last: "Down",
            rest: ""
        };

        SliderCore.rangeSlider(scaleSliders, start.y, labels, function(value) {
            ub.funcs.updatePositionViaSlider(applicationSettings, value, 'y');
        });
    },

    rotationSlider: function(applicationSettings) {
        var start = ApplicationCore.utilities.computeRotation(applicationSettings);
        var scaleSliders = document.querySelector(".slider-control-rotate");

        SliderCore.roundSlider(scaleSliders, start, function(args) {
            ub.funcs.updateRotationViaSlider(applicationSettings, args.value);
        });
    },

    opacitySlider: function(applicationSettings) {
        var start = typeof applicationSettings.alpha === "number" ? applicationSettings.alpha * 100 : 100;
        var scaleSliders = document.querySelector(".slider-opacity");
        var labels = {
            first:"1",
            last:"100",
            rest: ""
        };

        SliderCore.rangeSlider(scaleSliders, start, labels, function(value) {
            ub.funcs.changeMascotOpacity(applicationSettings.code, value);
        });
    },

    applicationPatternSlider: function(applicationSettings) {
        var _from = ub.uiData.patternSliderRange.starts;
        var _calibration = ub.uiData.patternSliderRange.adjustedStart;
        var _patternIsForCalibration = false;
        var max = ub.uiData.patternSliderRange.max;
        var min = ub.uiData.patternSliderRange.min;

        _patternIsForCalibration = _.contains(ub.uiData.patternSliderRange.forCalibration, applicationSettings.pattern_obj.name);

        if (typeof applicationSettings.pattern_settings !== "undefined" && applicationSettings.pattern_settings.length > 0) {
            _from = applicationSettings.pattern_settings.position.y;
            
            if (_patternIsForCalibration) {
                _from -= _patternIsForCalibration;
            }
        } else {
            _from = applicationSettings.pattern_settings.position.y;
        }

        var positionSlider = document.querySelector(".app-pattern-slider");
        var labels = {
            first: "Up",
            last: "Down",
            rest: ""
        };
        // For Color Wheel
        // SliderCore.rangeSliderVertical(positionSlider, _from, labels, function(value) {
        SliderCore.rangeSlider(positionSlider, _from, labels, function(value) {
            ub.funcs.changePatternPosition(applicationSettings.code, value);
            // update Specs panel (info container for ga)
            ub.updateApplicationSpecsPanel(applicationSettings.code);
        }, min, max);
    },

    mascotPatternScale: function(applicationSettings) {
        var scaleSliders = document.querySelector(".mascot-pattern-size");
        var primaryView = ub.funcs.getPrimaryView(applicationSettings.application);
        var patternObjectSettings = ub.objects[primaryView + '_view']["pattern_" + applicationSettings.code];
        var start = 10;

        var labelsSize = {
            first: "Small",
            last: "Large",
            rest: ""
        };

        if (typeof patternObjectSettings !== "undefined") {
            if (_.isObject(patternObjectSettings.children)) {
                var firstChild = _.first(patternObjectSettings.children);
                start = 300 * firstChild.scale.x;
            }
        }

        SliderCore.rangeSlider(scaleSliders, start, labelsSize, function(value) {
            var size = (parseInt(value) / 300);
            PatternMascot.core.updateMascotSize(applicationSettings, size);

            var matching = ub.data.matchingIDs.getMatchingID(applicationSettings.code);
            if (typeof matching !== "undefined") {
                var _matchingSettingsObject = _.find(ub.current_material.settings.applications, {code: matching.toString()});
                PatternMascot.core.updateMascotSize(_matchingSettingsObject, size);
            }
        });
    },

    mascotPatternPosition: function(applicationSettings) {
        var positionSlider = document.querySelector(".mascot-pattern-position");
        var primaryView = ub.funcs.getPrimaryView(applicationSettings.application);
        var patternObjectSettings = ub.objects[primaryView + '_view']["pattern_" + applicationSettings.code];
        // For Position
        var max = -160;
        var min = -500;
        var start = min;

        var labelsPosition = {
            first: "Up",
            last: "Down",
            rest: ""
        };

        if (applicationSettings.mascot_pattern_settings.position.y !== 0) {
            start = applicationSettings.mascot_pattern_settings.position.y;
        } else {
            if (typeof patternObjectSettings !== "undefined") {
                start = patternObjectSettings.position.y;
            }
        }

        SliderCore.rangeSlider(positionSlider, start, labelsPosition, function(value) {
            PatternMascot.core.updatePosition(applicationSettings, value);

            var matching = ub.data.matchingIDs.getMatchingID(applicationSettings.code);
            if (typeof matching !== "undefined") {
                var _matchingSettingsObject = _.find(ub.current_material.settings.applications, {code: matching.toString()});
                PatternMascot.core.updatePosition(_matchingSettingsObject, value);
            }
        }, min, max);
    },

    mascotPatternOpacity: function(applicationSettings) {
        var opacitySliders = document.querySelector(".mascot-pattern-opacity");
        var primaryView = ub.funcs.getPrimaryView(applicationSettings.application);
        var patternObjectSettings = ub.objects[primaryView + '_view']["pattern_" + applicationSettings.code];
        var start = 100;

        var labelsOpacity = {
            first: "1",
            last: "100",
            rest: ""
        };

        if (typeof patternObjectSettings !== "undefined") {
            start = Math.round(patternObjectSettings.alpha * 100);
        }

        SliderCore.rangeSlider(opacitySliders, start, labelsOpacity, function(value) {
            var opacity = parseInt(value) / 100;
            PatternMascot.core.updateOpacity(applicationSettings, opacity);

            var matching = ub.data.matchingIDs.getMatchingID(applicationSettings.code);
            if (typeof matching !== "undefined") {
                var _matchingSettingsObject = _.find(ub.current_material.settings.applications, {code: matching.toString()});
                PatternMascot.core.updateOpacity(_matchingSettingsObject, opacity);
            }
        });
    }
};